<template>
  <div>
    <div v-if="attachments.length > 0">
      <v-row class="mb-6 flex justify-center">
        <v-col
          cols="6"
          xl="4"
          v-for="tempAttachment in attachments"
          :key="tempAttachment.id"
          style="min-width: 376px; max-width: 400px;"
        >
          <v-card class="mx-auto pa-2">
            <v-img
              v-if="tempAttachment.dsMedia == 'imagem'"
              :src="tempAttachment.image"
              height="200px"
            ></v-img>
            <iframe
              v-if="tempAttachment.dsMedia == 'video'"
              height="193px"
              width="350px"
              :src="getYoutubeEmbed(tempAttachment.image)"
            ></iframe>

            <v-card-title class="text-left text-md-body-2">
              <span
                class="d-inline-block text-truncate"
                style="max-width: 230px;"
              >{{ tempAttachment.title }}</span>
            </v-card-title>

            <v-container style="padding-top: 0px;">
              <v-row style="margin: 0;">
                <v-checkbox
                  @change="updateCheck($event, 'flSegunda', tempAttachment)"
                  v-model="tempAttachment.flSegunda"
                  label="Seg"
                ></v-checkbox>
                <v-checkbox
                  @change="updateCheck($event, 'flTerca', tempAttachment)"
                  class="ml-4"
                  v-model="tempAttachment.flTerca"
                  label="Ter"
                ></v-checkbox>
                <v-checkbox
                  @change="updateCheck($event, 'flQuarta', tempAttachment)"
                  class="ml-4"
                  v-model="tempAttachment.flQuarta"
                  label="Qua"
                ></v-checkbox>
                <v-checkbox
                  @change="updateCheck($event, 'flQuinta', tempAttachment)"
                  class="ml-4"
                  v-model="tempAttachment.flQuinta"
                  label="Qui"
                ></v-checkbox>
                <v-checkbox
                  @change="updateCheck($event, 'flSexta', tempAttachment)"
                  v-model="tempAttachment.flSexta"
                  label="Sex"
                ></v-checkbox>
                <v-checkbox
                  @change="updateCheck($event, 'flSabado', tempAttachment)"
                  class="ml-4"
                  v-model="tempAttachment.flSabado"
                  label="Sab"
                ></v-checkbox>
                <v-checkbox
                  @change="updateCheck($event, 'flDomingo', tempAttachment)"
                  class="ml-4"
                  v-model="tempAttachment.flDomingo"
                  label="Dom"
                ></v-checkbox>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-menu
                    :ref="'comeca' + tempAttachment.id"
                    v-model="tempAttachment.menuComeca"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="tempAttachment.dtComeca"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="tempAttachment.dtComeca"
                        label="Inicio"
                        prepend-icon="mdi-clock-time-four-outline"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="tempAttachment.menuComeca"
                      v-model="tempAttachment.dtComeca"
                      full-width
                      format="24hr"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        @click="tempAttachment.menuComeca = false"
                        text
                        color="primary"
                      >Cancelar</v-btn>
                      <v-btn text color="primary" @click="saveBeginTime(tempAttachment)">Salvar</v-btn>
                    </v-time-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" md="6">
                  <v-menu
                    :ref="'termina' + tempAttachment.id"
                    v-model="tempAttachment.menuTermina"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="tempAttachment.dtTermina"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="tempAttachment.dtTermina"
                        label="Termina"
                        prepend-icon="mdi-clock-time-four-outline"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="tempAttachment.menuTermina"
                      v-model="tempAttachment.dtTermina"
                      full-width
                      format="24hr"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        @click="tempAttachment.menuTermina = false"
                        text
                        color="primary"
                      >Cancelar</v-btn>
                      <v-btn text color="primary" @click="saveEndTime(tempAttachment)">Salvar</v-btn>
                    </v-time-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-container>

            <v-card-actions>
              <v-btn @click="openDialog(tempAttachment)" color="red" outlined>Deletar</v-btn>

              <v-spacer></v-spacer>

              <v-btn @click="tempAttachment.show = !tempAttachment.show" text>
                Ver Imagem
                <v-icon>
                  {{
                  tempAttachment.show ? "mdi-chevron-up" : "mdi-chevron-down"
                  }}
                </v-icon>
              </v-btn>
            </v-card-actions>

            <v-expand-transition>
              <div v-show="tempAttachment.show">
                <v-divider></v-divider>

                <v-img :src="tempAttachment.image" height="auto"></v-img>
              </div>
            </v-expand-transition>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <div class="flex" v-else>
      <p class="grey--text">Não possui nenhum item</p>
    </div>
    <v-dialog v-model="dialog" max-width="390">
      <v-card>
        <v-card-title class="text-md-body-2">Voce realmente deseja excluir?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="darken-1" text @click="dialog = false">Cancelar</v-btn>
          <v-btn color="red darken-1" text @click="execute(deleteItem)">Deletar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "ListaAnexos",
  data() {
    return {
      dialog: false,
      deleteItem: null,
    };
  },
  methods: {
    openDialog(attachment) {
      if (!attachment) return;
      this.deleteItem = attachment;
      this.dialog = !this.dialog;
    },
    checkProgress(attachment) {
      return attachment.progress === null ? false : true;
    },
    execute(attachment) {
      if (!attachment) return;

      if (this.deleteFile) {
        this.deleteFile(attachment);
        this.deleteItem = null;
        this.dialog = !this.dialog;
      }
    },
    saveBeginTime(attachment) {
      this.$refs["comeca" + attachment.id][0].save(attachment.dtComeca);
      fetch(`${this.$menu_uri}/cardapio/${attachment.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          dtComeca: attachment.dtComeca || "",
          dtTermina: attachment.dtTermina || "",
        }),
      })
        .then((response) => response.json())
        .then(() => {
          this.$ons.notification.toast("Horário salvo!", {
            timeout: 1000,
            animation: "ascend",
          });
        });
    },
    saveEndTime(attachment) {
      this.$refs["termina" + attachment.id][0].save(attachment.dtTermina);
      fetch(`${this.$menu_uri}/cardapio/${attachment.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          dtComeca: attachment.dtComeca || "",
          dtTermina: attachment.dtTermina || "",
        }),
      })
        .then((response) => response.json())
        .then(() => {
          this.$ons.notification.toast("Horário salvo!", {
            timeout: 1000,
            animation: "ascend",
          });
        });
    },
    updateCheck(event, field, attachment) {
      fetch(`${this.$menu_uri}/cardapio/${attachment.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          dtComeca: "",
          dtTermina: "",
          [field]: event === false ? "0" : "1",
        }),
      })
        .then((response) => response.json())
        .then(() => {});
    },
    formatBytes(bytes, decimals = 2) {
      if (bytes === 0) return "0 Bytes";

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    },
    getYoutubeEmbed(url) {
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = url.match(regExp);

      const id = match && match[2].length === 11 ? match[2] : null;

      if (id) {
        return `https://www.youtube.com/embed/${id}`;
      }

      return null;
    },
  },
  props: {
    attachments: {
      type: Array,
    },
    deleteFile: {
      type: Function,
    },
  },
};
</script>

<style scoped>
.space-x-1 {
  padding: 1rem;
}
</style>
